module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("StockStream Live (Alpha)")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.connected) ? _c('div', [_c('h4', [_vm._v("Connecting...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row full-width"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "trades-remaining"
  }, [_vm._v(_vm._s(_vm.tradesRemaining) + " / " + _vm._s(_vm.totalTrades))])]), _vm._v(" "), (_vm.marketOpen) ? _c('div', {
    staticClass: "col"
  }, [_vm._m(3), _vm._v(" "), (_vm.transactionHistory && _vm.transactionHistory.length > 0) ? _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.transactionHistory), function(transaction) {
    return _c('p', [_c('span', {
      domProps: {
        "textContent": _vm._s(transaction.type.toUpperCase())
      }
    }), _vm._v(" " + _vm._s(transaction.symbol) + " @ " + _vm._s(transaction.shares) + " x " + _vm._s(_vm.formatPrice(transaction.price)) + "\n        ")])
  })) : _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("No data yet")])])]) : _c('div', {
    staticClass: "col text-center"
  }, [_c('h3', [_vm._v("Market Closed")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "compact"
  }, [_vm._v("Total: " + _vm._s(_vm.formatPrice(_vm.portfolioTotal + _vm.cashTotal)))]), _vm._v(" "), _c('p', {
    staticClass: "compact"
  }, [_vm._v("Cash: " + _vm._s(_vm.formatPrice(_vm.cashTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "compact"
  }, [_vm._v("Portfolio: " + _vm._s(_vm.formatPrice(_vm.portfolioTotal)))])])])])]), _vm._v(" "), (_vm.assets) ? _c('div', [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "bordered"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.assets), function(asset) {
    return _c('tr', [_c('td', {
      staticClass: "symbol text-left"
    }, [_c('a', {
      attrs: {
        "href": _vm.formatFinanceLink(asset.symbol),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(asset.symbol))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(asset.shares))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.averageCost)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.currentCost)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatChange(asset.change)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      style: ({
        backgroundColor: _vm.assetChangePercentToColor(asset)
      })
    }, [_vm._v(_vm._s(_vm.formatChangePercent(asset.changePercent)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.paidTotal)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.currentTotal)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatChange(asset.totalChange)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPercent(asset.percentPortfolio)))])])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Alpha site for a live-updating view of "), _c('a', {
    attrs: {
      "href": "https://www.twitch.tv/stockstream"
    }
  }, [_vm._v("StockStream")]), _vm._v("'s portfolio")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Historical data @ "), _c('a', {
    attrs: {
      "href": "https://stockstream.abal.moe/data"
    }
  }, [_vm._v("https://stockstream.abal.moe/data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Trades Remaining")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Transaction History")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Portfolio Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Portfolio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "symbol"
  }, [_vm._v("Symbol")]), _vm._v(" "), _c('th', [_vm._v("Shares")]), _vm._v(" "), _c('th', [_vm._v("Paid")]), _vm._v(" "), _c('th', [_vm._v("Current Price")]), _vm._v(" "), _c('th', [_vm._v("Change ($)")]), _vm._v(" "), _c('th', [_vm._v("Change (%)")]), _vm._v(" "), _c('th', [_vm._v("Paid Total")]), _vm._v(" "), _c('th', [_vm._v("Current Total")]), _vm._v(" "), _c('th', [_vm._v("Total Change")]), _vm._v(" "), _c('th', [_vm._v("% of Portfolio")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bbd84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 11
// module chunks = 0